export default __webpack_public_path__ + "static/media/Arc of Eternal Winter.5d68ae30.jpg";